import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// project import
import useAuth from 'hooks/useAuth';
import { getAppDefaultPath } from 'config';

// ==============================|| GUEST GUARD ||============================== //

export default function GuestGuard({ children }) {
  const { isLoggedIn, user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const path = getAppDefaultPath(user);

  useEffect(() => {
    if (isLoggedIn) {
      const from = location?.state?.from;
      navigate(from ? from : path, {
        state: from ? location?.state?.fromState ?? null : { from: '' },
        replace: true
      });
    }
  }, [isLoggedIn, navigate, location, path]);

  return children;
}

GuestGuard.propTypes = { children: PropTypes.any };
